import {
  Alert,
  Avatar,
  Box,
  CardHeader,
  Grid,
  Skeleton,
  Tab,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Stack } from "@mui/system";
import CakeIcon from "@mui/icons-material/Cake";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";
import { CheckOutlined, CloseOutlined, EditOutlined } from "@material-ui/icons";
import AppButton from "../shares/AppButton";
import PollOutlinedIcon from "@mui/icons-material/PollOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import { useNavigate } from "react-router-dom";
import { NA } from "../../../utils/utilities";
import { useQuery } from "../../../hooks/useQuery";
import AssociationForm from "./AssociationForm";
import useToast from "../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";
import { openLink } from "../../../Helpers/utilsHelper";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import { userServices } from "../../../service/UserService";
import AddIcon from "@mui/icons-material/Add";
import { ODK_ASSOCIATION_FORM } from "../offre/form/poste_data";
import useNotification from "../../../hooks/useNotification";
import { AssociationCandidatService } from "../../../service/AssociationCandidatService";
import { SendOutlined } from "@mui/icons-material";
import ListeMembreAssociation from "./ListeMembreAssociation";
import ExperienceProfessionnelsAssociation from "./ExperienceProfessionnelsAssociation";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import GroupsIcon from "@mui/icons-material/Groups";

const AssociationInfo = () => {
  const [currentAssociation, setCurrentAssociation] = useState({});
  const [titre, setTitre] = useState("Information du compte");
  const [offreDejaPostulees, setOffreDejaPostulees] = useState([]);
  const [associationFormOpen, setAssociationFormOpen] = useState(false);
  const navigate = useNavigate();
  const { Toast, showToast } = useToast();
  const { NotificationComponent, showNotification } = useNotification();
  const url = useQuery();
  const [loading, setLoading] = useState(false);

  const handleShowInfo = () => {
    setLoading(true);
    userServices
      .getMyAssociation()
      .then((res) => {
        if (res && res.data) {
          setCurrentAssociation(res.data);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleFetchApplyedPostByAssociationId = (asso_id) => {
    AssociationCandidatService.offrePostuleesByidAssociation(asso_id).then(
      (res) => {
        if (res && res.data) {
          setOffreDejaPostulees(res.data);
        }
      },
    );
  };

  const handleEditAssociation = (associationId) => {
    setAssociationFormOpen(true);
  };

  const handleCloseAssociationForm = () => {
    setAssociationFormOpen(false);
    handleShowInfo();
  };

  const getPostulableAssociation = () => {
    return {
      id_ext_association: currentAssociation.id_ext_association,
      id_type: url.get("job_id"),
    };
  };

  const handleConfirmSubmission = () => {
    AssociationCandidatService.postuler(getPostulableAssociation()).then(
      (res) => {
        if (res && res.success) {
          handleShowSuccessNotification();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      },
    );
  };

  const isSoumissionMode = () => {
    return (
      url.get("action") === "soummetre demande" && url.get("job_id") !== null
    );
  };

  const handleShowSuccessNotification = () => {
    showNotification(
      "Notification",
      "Soumission candidature volontariat avec succès",
      TYPE_NOTIFICATION.SUCCESS,
      () => {
        navigate("/offres");
      },
    );
  };

  const dejaPostulerACetteOffre = () => {
    return offreDejaPostulees.includes(url.get("job_id"));
  };

  const handleBackToApplicationForm = () => {
    if (url.get("job_id")) {
      navigate("/offres/postule?job_id=" + url.get("job_id"));
    } else {
      showToast(
        TYPE_NOTIFICATION.ERROR,
        "Veuillez selectionner une offre avant de postuler",
      );
    }
  };

  const createContenus = (show_experience = false) => {
    const tabs = [
      {
        title: "Liste membres",
        content: (
          <ListeMembreAssociation currentAssociation={currentAssociation} />
        ),
        icon: <GroupsIcon />,
        idx: "1",
      },
    ];

    const exp = {
      title: "Experiences",
      content: (
        <ExperienceProfessionnelsAssociation
          currentAssociation={currentAssociation}
        />
      ),
      icon: <ScienceOutlinedIcon />,
      idx: "2",
    };
    let res = tabs.slice();
    res = show_experience ? [...res, exp] : res;
    return res;
  };

  const handleChange = (event, newValue) => {
    url.set("ass_tab", newValue);
    navigate(`?${url.toString()}`);
  };

  const [contenus, setContenus] = useState([]);

  const tab_value = url.get("ass_tab") || "0";
  useEffect(() => {
    setContenus(createContenus(url.get("job_id") !== null));
  }, [currentAssociation]);

  useEffect(() => {
    handleShowInfo();
    url.set("ass_tab", "0");
    if (url.get("job_id")) {
    }
  }, []);

  useEffect(() => {
    if (
      url.get("action") === "soummetre demande" &&
      url.get("job_id") !== null
    ) {
      handleFetchApplyedPostByAssociationId(currentAssociation.uuid);
    }
  }, [currentAssociation.uuid]);

  useEffect(() => {
    if (
      url.get("action") === "soummetre demande" &&
      url.get("job_id") !== null
    ) {
      setTitre("Soumission candidature volontariat");
    } else {
      setTitre("Information de l'Agence/Association");
    }
  }, [url, currentAssociation.uuid]);

  return (
    <>
      <NotificationComponent />
      <Toast />
      <AssociationForm
        idAssociation={currentAssociation.uuid}
        open={associationFormOpen}
        onFormClose={handleCloseAssociationForm}
      />
      <Grid container m={2} display={loading ? "" : "none"}>
        <Skeleton width={"100%"} />
        <Skeleton width={"100%"} />
        <Skeleton width={"100%"} />
        <Skeleton width={"100%"} />
      </Grid>
      {!loading && (
        <>
          <Grid
            container
            display={
              JSON.stringify(currentAssociation) === "{}" ? "flex" : "none"
            }
            flexDirection={"column"}
            height={"50vh"}
          >
            <Grid display={"flex"} flexDirection={"column"} flexGrow={1}>
              <Grid item>
                <CardHeader
                  title={titre}
                  action={
                    <Grid container display={"flex"}>
                      <Grid m={0.5}>
                        <AppButton
                          text="Creer association"
                          variant="contained"
                          onClick={(e) =>
                            handleEditAssociation(currentAssociation.uuid)
                          }
                          icon={<AddIcon />}
                        />
                      </Grid>
                    </Grid>
                  }
                />
              </Grid>
              <Grid item flexGrow={0.5} m={5} alignContent={"center"}>
                <Alert>
                  <Typography>
                    aucune Agence / Association à gerer, veuillez ajouter
                    maintenant
                  </Typography>
                </Alert>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            display={JSON.stringify(currentAssociation) !== "{}" ? "" : "none"}
            // flexDirection={"column"}
          >
            <Grid
              m={0.5}
              display={
                !isSoumissionMode() || !dejaPostulerACetteOffre()
                  ? "none"
                  : "block"
              }
            >
              <Alert color="info"> Vous avez deja postuler à cette offre</Alert>
            </Grid>
            <CardHeader
              title={titre}
              titleTypographyProps={{ fontSize: "25px" }}
              action={
                <Grid container display={"flex"}>
                  <Grid m={0.5} display={url.get("job_id") ? "flex" : "none"}>
                    <AppButton
                      disabled={dejaPostulerACetteOffre()}
                      text="Postuler"
                      variant="contained"
                      color={"success"}
                      onClick={(e) => {
                        handleBackToApplicationForm();
                      }}
                      icon={<SendOutlined />}
                    />
                  </Grid>
                  <Grid m={0.5} display={isSoumissionMode() ? "none" : "block"}>
                    <AppButton
                      title={"Modifier l'information de l'agence/association"}
                      text="Modifier"
                      variant="contained"
                      onClick={(e) =>
                        handleEditAssociation(currentAssociation.uuid)
                      }
                      icon={<EditOutlined />}
                    />
                  </Grid>
                  <Grid
                    m={0.5}
                    display={!isSoumissionMode() ? "none" : "block"}
                  >
                    <AppButton
                      disabled={dejaPostulerACetteOffre()}
                      text="Valider candidature"
                      variant="contained"
                      color={"success"}
                      onClick={(e) => {
                        handleConfirmSubmission();
                      }}
                      icon={<CheckOutlined />}
                    />
                  </Grid>
                  <Grid
                    m={0.5}
                    display={!isSoumissionMode() ? "none" : "block"}
                  >
                    <AppButton
                      text="Fermer"
                      variant="contained"
                      color={"error"}
                      onClick={(e) => {
                        navigate("/offres");
                        // setTimeout(() => navigate("/offres"), 2500);
                      }}
                      icon={<CloseOutlined />}
                    />
                  </Grid>
                  <Grid
                    m={0.5}
                    display={!isSoumissionMode() ? "none" : "block"}
                  >
                    <AppButton
                      text={
                        isSoumissionMode()
                          ? "Soumetre formulaire"
                          : "Formulaire"
                      }
                      variant="outlined"
                      onClick={(e) => openLink(ODK_ASSOCIATION_FORM.link, true)}
                      icon={<AssignmentOutlinedIcon />}
                    />
                  </Grid>
                </Grid>
              }
            />
            <Grid>
              <CardHeader
                title={`${currentAssociation.nom || ""}`}
                titleTypographyProps={{ fontSize: "20px", fontWeight: "bold" }}
                subheader={
                  <Grid>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <CakeIcon />
                      <span>{`Crée en ${currentAssociation.annee_creation || ""}`}</span>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <LocationOnOutlinedIcon />
                      <span>{`${currentAssociation.adresse || NA()}`}</span>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <AccountBalanceOutlinedIcon />
                      <span>{`Nif: ${currentAssociation.num_nif || NA()}`}</span>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <PollOutlinedIcon />
                      <span>{`Stat: ${currentAssociation.num_stat || NA()}`}</span>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <HandshakeOutlinedIcon />
                      <span>{`Agrement: ${currentAssociation.agrement || NA()}`}</span>
                    </Stack>
                  </Grid>
                }
                avatar={
                  <Avatar
                    variant="rounded"
                    sx={{
                      m: 1,
                      width: "clamp(100px, 15vw, 150px)",
                      height: "clamp(100px, 15vw, 150px)",
                      fontSize: "clamp(40px, 8vw, 80px)",
                    }}
                    alt={currentAssociation.nom || "Asso"}
                    src={currentAssociation?.logo_link}
                  />
                }
              />
            </Grid>
            <Grid item xs={12} overflow={"auto"}>
              {/* <ListeMembreAssociation currentAssociation={currentAssociation} /> */}
              <TabContext value={tab_value}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                    variant="scrollable"
                    scrollButtons="auto"
                  >
                    {contenus.map((item, index) => (
                      <Tab
                        key={index}
                        label={item.title}
                        icon={item.icon}
                        iconPosition="start"
                        value={index.toString()}
                      />
                    ))}
                  </TabList>
                </Box>
                <Grid item>
                  {contenus.map((item, index) => (
                    <TabPanel key={index} value={index.toString()}>
                      {item.content}
                    </TabPanel>
                  ))}
                </Grid>
              </TabContext>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default AssociationInfo;
